(() => {
  const toInt = (value, fallback = 0) => {
    const number = Number.parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  };

  const formatMoney = (cents) => {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(Math.round(value), (window.theme && window.theme.moneyFormat) || '${{amount}}');
      }
    } catch (_) {}
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(value / 100);
  };

  const getScope = (slot) => slot.closest('product-info') || slot.closest('.shopify-section') || document;

  const getQuantityInput = (slot) => {
    const scope = getScope(slot);
    return scope.querySelector('.buy-button-container .qty__input') ||
      scope.querySelector('.product-form .qty__input') ||
      scope.querySelector('input[name="quantity"]');
  };

  const applyQuantityRule = (slot) => {
    const input = getQuantityInput(slot);
    if (!input) return;

    const min = Math.max(1, toInt(slot.dataset.quantityMin, 1));
    const step = Math.max(1, toInt(slot.dataset.quantityIncrement, 1));
    const max = slot.dataset.quantityMax ? Math.max(min, toInt(slot.dataset.quantityMax, min)) : null;

    input.min = String(min);
    input.step = String(step);
    if (max !== null) input.max = String(max);
    else input.removeAttribute('max');

    let value = toInt(input.value, min);
    if (value < min) value = min;
    if (max !== null && value > max) value = max;
    if ((value - min) % step !== 0) value = min + Math.ceil((value - min) / step) * step;
    if (max !== null) value = Math.min(value, max);
    input.value = String(value);

    const scope = getScope(slot);
    const hiddenQuantity = scope.querySelector('#varquantity');
    if (hiddenQuantity) hiddenQuantity.value = String(value);

    const qtyShell = input.closest('.qty');
    if (qtyShell) {
      qtyShell.dataset.min = String(min);
      qtyShell.dataset.step = String(step);
      if (max !== null) qtyShell.dataset.max = String(max);
      else delete qtyShell.dataset.max;
    }
  };

  const findPriceRow = (table, quantity) => {
    const rows = [...table.querySelectorAll('[data-catalog-price-row]')];
    return rows.find((row) => {
      const min = Math.max(1, toInt(row.dataset.min, 1));
      const max = row.dataset.max ? toInt(row.dataset.max, Number.MAX_SAFE_INTEGER) : Number.MAX_SAFE_INTEGER;
      return quantity >= min && quantity <= max;
    }) || rows[0] || null;
  };

  const refreshSlot = (slot, explicitQuantity = null) => {
    if (!(slot instanceof Element)) return;
    applyQuantityRule(slot);

    const table = slot.querySelector('[data-catalog-pricing-table]');
    if (!table) return;

    const input = getQuantityInput(slot);
    const quantity = Math.max(1, explicitQuantity ?? toInt(input?.value, toInt(slot.dataset.quantityMin, 1)));
    const row = findPriceRow(table, quantity);

    table.querySelectorAll('[data-catalog-price-row]').forEach((item) => item.classList.toggle('is-active', item === row));
    const currentPrice = table.querySelector('[data-catalog-current-price]');
    if (currentPrice && row) currentPrice.textContent = formatMoney(row.dataset.priceCents);
  };

  const refresh = (root = document) => {
    if (root.matches?.('[data-catalog-pricing-slot]')) refreshSlot(root);
    root.querySelectorAll?.('[data-catalog-pricing-slot]').forEach((slot) => refreshSlot(slot));
  };

  document.addEventListener('input', (event) => {
    if (!event.target.matches?.('.qty__input, input[name="quantity"]')) return;
    const scope = event.target.closest('product-info') || event.target.closest('.shopify-section') || document;
    scope.querySelectorAll('[data-catalog-pricing-slot]').forEach((slot) => refreshSlot(slot));
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('.qty__input, input[name="quantity"]')) return;
    const scope = event.target.closest('product-info') || event.target.closest('.shopify-section') || document;
    scope.querySelectorAll('[data-catalog-pricing-slot]').forEach((slot) => refreshSlot(slot));
  });

  // Plasticare's custom +/- quantity controls update the input through jQuery and
  // trigger a jQuery change event. Native addEventListener handlers don't always
  // receive that synthetic event, so refresh after the button click as well.
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.qty__btn[data-action]');
    if (!button) return;

    const scope = button.closest('product-info') || button.closest('.shopify-section') || document;
    requestAnimationFrame(() => {
      scope.querySelectorAll('[data-catalog-pricing-slot]').forEach((slot) => refreshSlot(slot));
    });
  });

  document.addEventListener('DOMContentLoaded', () => refresh(document));
  document.addEventListener('product-info:loaded', (event) => refresh(event.target));

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('[data-catalog-pricing-slot]') || node.querySelector('[data-catalog-pricing-slot]')) {
          refresh(node);
        }
      }
    }
  });

  if (document.documentElement) observer.observe(document.documentElement, { childList: true, subtree: true });

  window.PlasticareCatalogPricing = {
    refresh,
    refreshSlot,
    getPriceCents(slot, quantity) {
      const table = slot?.querySelector?.('[data-catalog-pricing-table]');
      const row = table ? findPriceRow(table, Math.max(1, toInt(quantity, 1))) : null;
      return row ? Number(row.dataset.priceCents) : null;
    },
  };
})();
